import gql from 'graphql-tag';

const STOCKTAKES_FRAGMENT = gql`
	fragment stocktakes on Stocktake {
		id
		created
		date
		lastSubmit
		status
		percentageDifference
		valueOfDifference
		valueNotAccurate
		description
		warehouse {
			id
			name
		}
		user {
			id
			firstname
			lastname
			destroyed
		}
	}
`;

export const GET_STOCKTAKES = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: StocktakePageFilter
	) {
		getStocktakes(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...stocktakes
			}
			count
		}
	}
	${STOCKTAKES_FRAGMENT}
`;
